import React from 'react';

import { useMobileRobotViewAvailability } from '../../../../utils/hooks';
import { useRobotSelector } from '../../context';
import { RobotViewBlocklyPythonMobile } from './_mobile/robot_view_blockly-python_mobile';
import { RobotViewBlocklyPythonDesktop } from './_desktop/robot_view_blockly-python_desktop';

export const RobotViewBlocklyPython = () => {
    const shouldShowMobileRobotView = useMobileRobotViewAvailability(useRobotSelector((context) => context.problem));

    return shouldShowMobileRobotView ? <RobotViewBlocklyPythonMobile /> : <RobotViewBlocklyPythonDesktop />;
};
